import { render, staticRenderFns } from "./School.vue?vue&type=template&id=02ff39d5&scoped=true&"
import script from "./School.ts?vue&type=script&lang=ts&"
export * from "./School.ts?vue&type=script&lang=ts&"
import style0 from "./school.scss?vue&type=style&index=0&id=02ff39d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ff39d5",
  null
  
)

export default component.exports